/*
 对js部分原型对象进行扩展，添加一些实用方法，重写了一些方法
 update: 2021-06-06
*/
/**
 * @returns {number}
 * 计算两个时间相差多少天
 */

// 将日期字符串格式化为年月日时分秒
Date.parseString = function (str = "") {
    const value = str.replace(" ", ":").replace(/:/g, "-").split("-")
    value[1] = parseInt(value[1]) - 1
    return new Date(...value)
}
/**
 * @returns {string}
 * 首字母大写 capitalize
 */
// eslint-disable-next-line no-extend-native
String.prototype.title = function () {
    return this.charAt(0).toUpperCase() + this.slice(1)
}

/** @param {any} obj
 *  @returns {Boolean}
 * 是否为对象
 */
Object.isObj = function (obj) {
    return Object.prototype.toString.call(obj) === "[object Object]"
}

/** @param { Object } obj
 *  @returns {Boolean}
 * 是否为空对象 只要对象中一个属性不为空，那么该对象就不为空
 */
Object.isEmptyObj = function (obj) {
    if (obj == null) return true
    const keys = Object.keys(obj)
    if (keys.length) {
        let flag = true
        for (const item of keys) {
            if (obj[item]) {
                flag = false
                break
            }
        }
        return flag
    } else {
        return true
    }
}

/** 深度克隆一个对象
 *  @returns {Object}
 *  @param {Object} obj
 *  @param {Array} excludeProps 排除需要克隆的对象
 */
Object.deepClone = function (obj, excludeProps = []) {
    // 对常见的“非”值，直接返回原来值
    if ([null, undefined, NaN, false].includes(obj)) return obj
    if (typeof obj !== "object" && typeof obj !== "function") {
        // 原始类型直接返回
        return obj
    }
    const o = Array.isArray(obj) ? [] : {}
    for (const i in obj) {
        // eslint-disable-next-line no-prototype-builtins
        if (excludeProps.includes(i)) {
            o[i] = obj[i]
        } else {
            o[i] = typeof obj[i] === "object" ? Object.deepClone(obj[i], excludeProps) : obj[i]
        }
    }
    return o
}
/** 深度合并多个对象
 *  @param {Object} target
 *  @param {Object} source
 *  @returns {Object}
 */
Object.deepAssign = function (target = {}, source = {}) {
    return Object.deepClone(Object.assign(...arguments))
}

/** 深度合并两个对象
 *  @param {Object} target
 *  @param {Object} source
 *  @param {Boolean} isDeep
 *  @returns {Object}
 */
Object.merge = function (target = {}, source = {}, isDeep) {
    if (isDeep) {
        target = Object.deepClone(target)
    }
    if (typeof target !== "object" || typeof source !== "object") return false
    for (var prop in source) {
        // eslint-disable-next-line no-prototype-builtins
        if (!source.hasOwnProperty(prop)) continue
        if (prop in target) {
            if (typeof target[prop] !== "object") {
                target[prop] = source[prop]
            } else {
                if (typeof source[prop] !== "object") {
                    target[prop] = source[prop]
                } else {
                    if (target[prop].concat && source[prop].concat) {
                        // for (let i = 0; i < source[prop].length; i++) {
                        //   if (Object.isObj(source[prop][i])) {
                        //     target[prop][i] = Object.deepMerge(source[prop][i], target[prop][i])
                        //   } else {
                        //     target[prop][i] = source[prop][i]
                        //   }
                        // }
                        target[prop] = source[prop]
                    } else {
                        target[prop] = Object.merge(target[prop], source[prop])
                    }
                }
            }
        } else {
            target[prop] = source[prop]
        }
    }
    return target
}

/**
 * 判断是否为空
 */
Object.isEmpty = function (value) {
    switch (typeof value) {
    case "undefined":
        return true
    case "string":
        // eslint-disable-next-line eqeqeq
        if (value.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, "").length == 0) return true
        break
    case "boolean":
        if (!value) return true
        break
    case "number":
        if (value === 0 || isNaN(value)) return true
        break
    case "object":
        if (value === null || value.length === 0) return true
        for (var i in value) {
            return false
        }
        return true
    }
    return false
}
/** 缓动函数
 *  @returns {Number}
 *  @param {Number} t 当前时间
 *  @param {Object} b 开始未知
 *  @param {Object} c 变化值
 *  @param {Object} d 持续时间
 */
Math.easeInOutQuad = function (t, b, c, d) {
    t /= d / 2
    if (t < 1) {
        return c / 2 * t * t + b
    }
    t--
    return -c / 2 * (t * (t - 2) - 1) + b
}
